import { QueryKey } from 'api/queryKey';
import React, { createContext, FC, useEffect } from 'react';
import { DictionaryService } from 'core/dictionary.service';
import { useQuery } from 'react-query';
import { Dictionary } from '@summer/react-kit/dictionaries/types';
import { useSelector } from 'react-redux';
import { isAuthenticatedSelector } from 'state/auth/auth.selectors';
import { FullPageLoader } from 'common/components/FullPageLoader';
import { AppIntlContext } from 'core/intl/AppIntlProvider';

export const HigoDictionaryContext = createContext<Dictionary | undefined>({});

export const HigoDictionaryProvider: FC = ({ children }) => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const { currentLanguage } = React.useContext(AppIntlContext);

  const { data, refetch } = useQuery(
    QueryKey.DictionaryList,
    DictionaryService.fetch
  );

  useEffect(() => {
    refetch();
  }, [currentLanguage, refetch]);

  return (
    <HigoDictionaryContext.Provider value={data}>
      {!data && isAuthenticated ? <FullPageLoader /> : children}
    </HigoDictionaryContext.Provider>
  );
};
